import * as React from 'react';

import classNames from 'classnames';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import { EMainMenuCounters, ERefsLeftMenu } from '@enums';

import { getConfig, URLS } from '@base/constants';
import { getTranslation, translations } from '@base/utils';

import { MainMenuAppsSet, MainMenuItem, MainMenuSet, MainMenuUserHuge } from '@components';

import {
	// IconRegistration,
	IconSignIn,
	IconSignOut,
} from '@icons';

import { IMainMenuViewProps } from './MainMenuView';

import s from './MainMenuView.scss';

export const MainMenuTwaView: React.FC<IMainMenuViewProps> = ({
	className,
	onLogOutClick,
	onLogInClick,
	// onRegistrationClick,
	currentUser,
	menuApps: {
		myApps,
		suggestApps,
	},
	isVisible,
	mainMenuViewRef,
	onHide,
}: IMainMenuViewProps) => {
	const t = getTranslation('components.MainMenu');
	const {
		avatar,
		name,
		isMyCreated,
		dir,
		sumMailiki,
	} = currentUser;
	const menuClassName = classNames(
		className,
		s.block,
		{ [s.visible]: isVisible },
	);

	return (
		<div
			className={menuClassName}
			ref={mainMenuViewRef}
		>
			<LazyLoadComponent visibleByDefault={!getConfig().isMobile}>
				<div className={s.innerWrapper}>
					{ /* Блок пользователя */}
					{isMyCreated && (
						<MainMenuSet>
							<MainMenuUserHuge
								className={s.userTwa}
								avatar={avatar?.url?.size45}
								link={dir || ''}
								name={name?.full}
								balance={sumMailiki}
								onClick={onHide}
							/>
						</MainMenuSet>
					)}

					<MainMenuSet>
						{ /* Выход из профиля */}
						{!isMyCreated && <>
							{ /* Авторизация */}
							<MainMenuItem
								title={t('login')}
								onClick={onLogInClick}
								link={URLS.MAIN}
								icon={IconSignIn}
								counter={EMainMenuCounters.LOGIN}
							/>

							{(getConfig().isTwa && !!getConfig().createMyWarning) &&
								<div className={s.warning}>{getConfig().createMyWarning}</div>
							}
							{ /* Регистрация */}
							{/* <MainMenuItem*/}
							{/*	title={t('registration')}*/}
							{/*	onClick={onRegistrationClick}*/}
							{/*	icon={IconRegistration}*/}
							{/*	counter={EMainMenuCounters.REGISTRATION}*/}
							{/* />*/}
						</>
						}
					</MainMenuSet>

					{ /* Ссылки на "Мои игры" */}
					{isMyCreated && !!myApps?.length &&
						<MainMenuAppsSet
							appsArray={myApps}
							title={translations.appCatalog('appsMy')}
							isMyCreated={isMyCreated}
						/>
					}

					{ /* Ссылки на игры раздела "Рекомендуем" */}
					{!!suggestApps?.length &&
						<MainMenuAppsSet
							appsArray={suggestApps}
							title={translations.common('suggest')}
							isMyCreated={isMyCreated}
							customRef={ERefsLeftMenu.GAMES_PROMO}
						/>
					}

					<MainMenuSet>
						{ /* Выход из профиля */}
						{isMyCreated && <MainMenuItem
							title={t('logout')}
							onClick={onLogOutClick}
							icon={IconSignOut}
							counter={EMainMenuCounters.LOGOUT}
						/>
						}
					</MainMenuSet>

				</div>
			</LazyLoadComponent>
		</div>
	);
};
